import React from 'react'
import PropTypes from 'prop-types'
import { SubmissionError } from 'redux-form'
import { isApiError } from 'services/rest/helpers'
import { INPUT_MAX_LENGTH } from 'constant'
import { rest } from 'services'
import prepareForm from 'helpers/prepare-form'
import { rules } from './validatorConfig'
import form from './form'
import enhance from './enhancer'
import CreateAccountFormPageWrapper from './CreateAccountFormPageWrapper'
import { RECAPTCHA_MESSAGE } from './constants'
import { isEqual } from 'lodash'

/* eslint-disable react/sort-comp */
class CreateAccountFormPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errorBannerRef: null,
      errorFocus: false,
      isReCaptchaVerified: true,
      notVerifiedReCaptchaMessage: ''
    }
    this.captchaRef = React.createRef()
  }

  componentDidUpdate({ values: { password: prevPassword }}) {
    const { error, values: { password = '' } = {}, change } = this.props
    const { errorBannerRef, errorFocus } = this.state

    if (password && !isEqual(prevPassword, password)) {
      change(form.hiddenField.name, password)
    }

    if (error && errorFocus) {
      window.scrollTo(0, 0)
      errorBannerRef && errorBannerRef.focus && errorBannerRef.focus()
      this.handleResetErrorFocus()
    }
  }

  handleApiFailure = err => {
    this.setState({ errorFocus: true })

    throw isApiError(err) ?
      new SubmissionError({ _error: err.errors.length ? err.errors : err.status.description }) :
      err
  }

  handleRedirect = () => {
    this.props.redirectTo(this.props.myAccountLink.path)
  }

  handleResetErrorFocus = () => this.setState({ errorFocus: false })

  setInnerRef = el => { this.state.errorBannerRef = el }

  setIsReCaptchaVerified = (value) => {
    this.setState({ isReCaptchaVerified: value })
  }

  resetNotVerifiedReCaptchaMessage = () => {
    this.setState({ notVerifiedReCaptchaMessage: '' })
  }

  submit = () => {
    const {
      values
    } = this.props
    const { isReCaptchaVerified } = this.state

    if (!isReCaptchaVerified) {
      this.setState({ notVerifiedReCaptchaMessage: RECAPTCHA_MESSAGE })

      return
    }

    return this.props.mergeApiDecorator({
      api: rest.api.registration,
      payload: prepareForm(values),
      handleSuccess: this.handleRedirect,
      data: {
        isFormSubmission: true,
        userSignIn: true,
        emailCaptured: values.login,
        emailSubmissionLocation: window.location.href,
        firstName: values.firstName,
        lastName: values.lastName
      },
      googleAnalyticEmailAddressFill: this.props.googleAnalyticEmailAddressFill
    })
      .catch(this.handleApiFailure)
  }

  render() {
    const {
      userNameNotes,
      instructions,
      communicationOptionInstruction,
      termsLink: { path } = {},
      // connect properties
      values,
      isPasswordFieldActive,
      // redux-form properties
      error = '',
      submitting,
      handleSubmit
    } = this.props

    return (
      <CreateAccountFormPageWrapper
        form={ form }
        captchaRef={ this.captchaRef }
        rules={ rules }
        error={ error }
        values={ values }
        maxLength={ INPUT_MAX_LENGTH }
        emailNote={ userNameNotes }
        instructions={ instructions }
        keepInContactInstructions={ communicationOptionInstruction }
        termsPagePath={ path }
        isSubmitting={ submitting }
        isPasswordFieldActive={ isPasswordFieldActive }
        handlers={ this.handlers }
        handleSubmit={ handleSubmit }
        handleCustomSubmit={ this.submit }
        handleRedirect={ this.handleRedirect }
        setIsReCaptchaVerified={ this.setIsReCaptchaVerified }
        notVerifiedReCaptchaMessage={ this.state.notVerifiedReCaptchaMessage }
        resetNotVerifiedReCaptchaMessage={ this.resetNotVerifiedReCaptchaMessage }
        setInnerRef={ this.setInnerRef } />
    )
  }
}

CreateAccountFormPage.propTypes = {
  change: PropTypes.func,
  communicationOptionInstruction: PropTypes.string,
  error: PropTypes.node,
  googleAnalyticEmailAddressFill: PropTypes.func,
  handleSubmit: PropTypes.func,
  instructions: PropTypes.string,
  isPasswordFieldActive: PropTypes.bool,
  mergeApiDecorator: PropTypes.func,
  myAccountLink: PropTypes.shape({
    path: PropTypes.string
  }),
  profilePopulationData: PropTypes.shape({}),
  redirectTo: PropTypes.func,
  submitting: PropTypes.bool,
  termsLink: PropTypes.shape({
    path: PropTypes.string
  }),
  userNameNotes: PropTypes.string,
  values: PropTypes.shape()
}

const EnhancedCreateAccountFormPage = enhance(CreateAccountFormPage)

EnhancedCreateAccountFormPage.type = 'RegisterUserForm'

export default EnhancedCreateAccountFormPage
